import { render, staticRenderFns } from "./SortReviewButton.vue?vue&type=template&id=7beb4062&scoped=true&lang=pug"
import script from "./SortReviewButton.vue?vue&type=script&lang=js"
export * from "./SortReviewButton.vue?vue&type=script&lang=js"
import style0 from "./SortReviewButton.vue?vue&type=style&index=0&id=7beb4062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7beb4062",
  null
  
)

export default component.exports